import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useId, useRef, useState } from "react";
import { SHELL_TEXT } from "../content.js";
import { FONT_SCALE_STEPS } from "../generated/tokens.js";
import { IconType } from "../icons.js";
/**
 * Botão "Letra" do cabeçalho e o painel de leitura (D84): A, A+ e A++ e o interruptor de alto contraste.
 * Painel não modal: abre abaixo do botão, fecha com Esc (o foco volta ao botão) ou com clique fora.
 */
export function ReadingControl({ prefs, onChange, text }) {
    const t = { ...SHELL_TEXT, ...text };
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);
    const toggleRef = useRef(null);
    const panelId = useId();
    const titleId = useId();
    useEffect(() => {
        if (!open)
            return;
        const onKey = (e) => {
            if (e.key === "Escape") {
                setOpen(false);
                toggleRef.current?.focus();
            }
        };
        const onPointer = (e) => {
            if (rootRef.current && !rootRef.current.contains(e.target))
                setOpen(false);
        };
        document.addEventListener("keydown", onKey);
        document.addEventListener("pointerdown", onPointer);
        // O foco vai para a escolha atual: quem abriu o painel quer mudar a letra.
        rootRef.current?.querySelector('[aria-pressed="true"]')?.focus();
        return () => {
            document.removeEventListener("keydown", onKey);
            document.removeEventListener("pointerdown", onPointer);
        };
    }, [open]);
    return (_jsxs("div", { className: "we-reading", ref: rootRef, children: [_jsxs("button", { ref: toggleRef, type: "button", className: "we-reading__toggle", "aria-expanded": open, "aria-controls": panelId, onClick: () => setOpen((v) => !v), children: [_jsx(IconType, {}), _jsx("span", { children: t.letra })] }), _jsx("div", { id: panelId, className: "we-reading__panel", hidden: !open, role: "group", "aria-labelledby": titleId, children: _jsx(ReadingOptions, { prefs: prefs, onChange: onChange, text: text, titleId: titleId }) })] }));
}
/**
 * As opções do painel de leitura (D84): tamanho da letra e alto contraste, com a nota. Ficam dentro do
 * botão "Letra" do cabeçalho e, abertas, na seção "Leitura" do Perfil (`07_VOZ` §5e.8, item 60).
 */
export function ReadingOptions({ prefs, onChange, text, titleId, }) {
    const t = { ...SHELL_TEXT, ...text };
    return (_jsxs(_Fragment, { children: [_jsx("p", { id: titleId, className: "we-reading__title", children: t.tamanhoDaLetra }), _jsx("div", { className: "we-reading__sizes", children: Object.keys(FONT_SCALE_STEPS).map((step) => (_jsx("button", { type: "button", className: "we-reading__size", "aria-pressed": prefs.fontScale === step, "aria-label": t.letraOpcoes[step], style: { "--we-sample": FONT_SCALE_STEPS[step] }, onClick: () => onChange({ fontScale: step }), children: _jsx("span", { "aria-hidden": "true", children: step }) }, step))) }), _jsxs("button", { type: "button", role: "switch", "aria-checked": prefs.highContrast, className: "we-switch", onClick: () => onChange({ highContrast: !prefs.highContrast }), children: [_jsx("span", { className: "we-switch__label", children: t.altoContraste }), _jsx("span", { className: "we-switch__track", "aria-hidden": "true", children: _jsx("span", { className: "we-switch__thumb" }) })] }), _jsx("p", { className: "we-reading__note", children: t.leituraNota })] }));
}
